export const PROTOCOL_VERSION = '1.0.0';
export const GAME_CONSTANTS = {
    // Tick rate & simulation step
    SERVER_TICK_RATE: 30, // 30 Hz
    FIXED_DELTA_TIME: 1 / 30,
    SNAPSHOT_RATE: 20, // 20 Hz
    SNAPSHOT_INTERVAL: 1 / 20,
    // Arena & boundaries
    ARENA_SIZE: 400, // 400x400 meters centered at (0,0)
    ARENA_BOUNDARY_MIN: -195,
    ARENA_BOUNDARY_MAX: 195,
    // Tank dimensions and physical dynamics
    TANK_WIDTH: 3.4,
    TANK_LENGTH: 6.8,
    TANK_HEIGHT: 2.4,
    TANK_MASS: 42000, // kg
    MAX_FORWARD_SPEED: 14.0, // m/s (~50 km/h)
    MAX_REVERSE_SPEED: 6.0, // m/s (~22 km/h)
    ACCELERATION: 7.5, // m/s^2
    BRAKE_DECELERATION: 12.0, // m/s^2
    NATURAL_DECELERATION: 3.0,
    TURN_RATE: 1.15, // rad/s (steer angular speed)
    REVERSE_TURN_MULTIPLIER: 0.8,
    SUSPENSION_STIFFNESS: 15.0,
    SUSPENSION_DAMPING: 5.0,
    // Turret and gun properties
    TURRET_TURN_SPEED: 1.2, // rad/s
    GUN_ELEVATION_SPEED: 0.6, // rad/s
    GUN_MIN_PITCH: -0.14, // ~ -8 degrees depression
    GUN_MAX_PITCH: 0.35, // ~ +20 degrees elevation
    BARREL_LENGTH: 4.2, // meters forward from turret center
    TURRET_HEIGHT_OFFSET: 1.8, // meters above ground
    // Combat parameters
    MAX_HEALTH: 100,
    RELOAD_TIME: 2.8, // seconds between shots
    PROJECTILE_SPEED: 150.0, // m/s
    PROJECTILE_GRAVITY: 9.81, // m/s^2
    PROJECTILE_LIFETIME: 5.0, // seconds
    PROJECTILE_RADIUS: 0.35, // collision radius
    DIRECT_HIT_DAMAGE: 35,
    SPLASH_DAMAGE: 15,
    SPLASH_RADIUS: 4.5,
    RESPAWN_DELAY: 4.0, // seconds after death
    // Match parameters
    DEFAULT_MATCH_DURATION: 300, // 5 minutes
    MAX_PLAYERS_PER_ROOM: 16,
    BOT_COUNT_DEFAULT: 4,
    // Network thresholds
    MAX_MESSAGE_SIZE: 16384, // 16 KB max WebSocket message
    RATE_LIMIT_INPUTS_PER_SEC: 60,
    PING_INTERVAL_MS: 3000,
    DISCONNECT_TIMEOUT_MS: 15000,
};
//# sourceMappingURL=constants.js.map